import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.429 5.778H7.714C6.768 5.778 6 6.574 6 7.556v10.666C6 19.204 6.768 20 7.714 20h8.572c.947 0 1.714-.796 1.714-1.778V7.556c0-.982-.767-1.778-1.714-1.778H14.57m-5.142 0c0 .982.767 1.778 1.714 1.778h1.714c.947 0 1.714-.796 1.714-1.778m-5.142 0c0-.982.767-1.778 1.714-1.778h1.714c.947 0 1.714.796 1.714 1.778M12 12h2.571M12 15.556h2.571M9.43 12h.008m-.008 3.556h.008",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render };